<template>
    <list-search v-bind="{ showsSearch }" @search="setQuery">
        <v-row align="center" class="ma-n2">
            <v-col class="pa-2" cols="12" sm="12" md="4">
                <v-select label="검색대상" v-model="query.searchKey" :items="searchKeys" v-bind="attrs_input" />
            </v-col>
            <v-col class="pa-2" cols="12" sm="6" md="4">
                <v-text-field v-model="query.searchValue" label="검색어" clearable v-bind="attrs_input" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import { attrs_input, USER_TYPES } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";
import AutocompleteUser from "@/components/dumb/autocomplete-user.vue";

let initQuery = (query = {}) => ({
    ...query,
    ["searchKey"]: query?.["searchKey"] || null,
    ["searchValue"]: query?.["searchValue"] || null,
});

const searchKeys = [
    { text: "전체", value: null },
    { text: "제목", value: "subject" },
    { text: "내용", value: "content" },
    { text: "한줄설명", value: "summary" },
    { text: "태그", value: "tags" },
];

export default {
    components: {
        ListSearch,
        AutocompleteUser,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        searchKeys,

        attrs_input,
        USER_TYPES,
    }),
    mounted() {
        this.sync();
    },

    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        setQuery() {
            const { ...query } = this.query || {};

            if (!query?.["searchKey"]) delete query["searchKey"];
            if (!query?.["searchValue"]) delete query["searchValue"];

            query.page = 1;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
